'use client';
import { useAuth } from '@/contexts/AuthContext';
import SubscriptionPrompt from '@/components/common/SubscriptionPrompt';

export default function SubscriptionPromptWrapper() {
  const { showSubscriptionPrompt, setShowSubscriptionPrompt } = useAuth();
  return (
    <SubscriptionPrompt
      isOpen={showSubscriptionPrompt}
      onClose={() => setShowSubscriptionPrompt(false)}
    />
  );
}